import React from 'react'

import { tokenVar } from '../../theme/tokenVar'

export type PictureInPictureExitIconProps = {
  size?: number
  color?: string
  colorScheme?: 'dark' | 'light'
  className?: string
}

// No design-library glyph exists for exiting picture-in-picture yet. Drawn from the
// Lucide "picture-in-picture" glyph (arrow returning to the main screen) scaled to the
// 20×20 icon grid (stroke 1.5, round caps) to match Foundation iconography. Replace
// with the library asset when one lands.
export const PictureInPictureExitIcon = ({
  size = 20,
  color,
  colorScheme = 'dark',
  className,
}: PictureInPictureExitIconProps) => {
  const resolvedColor =
    color ??
    tokenVar(
      colorScheme === 'light'
        ? 'colors.light.icon.secondary'
        : 'colors.icon.secondary'
    )
  return (
    <svg
      aria-label='Disable picture in picture'
      className={className}
      fill='none'
      height={size}
      role='img'
      viewBox='0 0 20 20'
      width={size}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M1.6667 8.3333H6.6667V3.3333'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
      />
      <path
        d='M1.6667 3.3333L6.6667 8.3333'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
      />
      <path
        d='M17.5 8.3333V5.8333C17.5 4.9129 16.7538 4.1667 15.8333 4.1667H10'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
      />
      <path
        d='M2.5 11.6667V13.3333C2.5 14.2538 3.2462 15 4.1667 15H6.6667'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
      />
      <rect
        height='5.8333'
        rx='0.8333'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
        width='8.3333'
        x='10'
        y='11.6667'
      />
    </svg>
  )
}
